module.exports = __webpack_public_path__ + "img/typing_wait_2.d2c03cb9.png";